// extracted by mini-css-extract-plugin
export default {"value":"EJY64AZSYP4qMw8J4mu_"};